export default "__VITE_ASSET__C4KtqSB6__"